"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSet = void 0;
const echain_math_1 = require("@igus/echain-math");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_product_models_1 = require("@igus/echain-product-models");
class MontageSet extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'MontageSet';
    }
    get ausfuehrung() {
        return this.model.Ausfuehrung;
    }
    set ausfuehrung(value) {
        this.model.Ausfuehrung = value;
    }
    get bestTyp() {
        return this.model.BestTyp;
    }
    set bestTyp(value) {
        this.model.BestTyp = value;
    }
    get gewicht() {
        return echain_shared_quantities_1.Q.optional(this.model.Gewicht);
    }
    set gewicht(value) {
        this.model.Gewicht = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get opti() {
        return this.model.Opti;
    }
    set opti(value) {
        this.model.Opti = value;
    }
    get isSet() {
        return this.model.IsSet;
    }
    set isSet(value) {
        this.model.IsSet = value;
    }
    static fromScratch() {
        return new MontageSet({
            ArticleType: echain_product_models_1.ArticleType.montageSet,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'MontageSet.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const montageSet = MontageSet.fromJson(args, cloneStrategy);
        montageSet.artNrExists = true;
        return montageSet;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'MontageSet.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const montageSet = MontageSet.fromJson(args, cloneStrategy);
        montageSet.artNrExists = false;
        montageSet.artNr = undefined;
        return montageSet;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const montageSet = MontageSet.fromScratch();
        montageSet.fromJson(args, cloneStrategy);
        return montageSet;
    }
    static fromModel(model) {
        const montageSet = MontageSet.fromScratch();
        Object.assign(montageSet.model, model);
        Object.assign(model, montageSet.model);
        montageSet.model = model;
        return montageSet;
    }
    clone() {
        return this._clone(MontageSet.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    isMontageSetMitCProfil() {
        return (this.opti === echain_shared_articles_1.MontageSetOpti.MONTAGE_SET_MIT_C_PROFIL ||
            this.opti === echain_shared_articles_1.MontageSetOpti.BEFESTIGUNG_AUSSEN_MIT_C_PROFIL ||
            this.opti === echain_shared_articles_1.MontageSetOpti.BEFESTIGUNG_INNEN_MIT_C_PROFIL);
    }
    isMontageSetOhneCProfil() {
        return this.opti === echain_shared_articles_1.MontageSetOpti.OHNE_C_PROFIL_ALLE_BREITEN;
    }
    isFestpunktModul() {
        return this.opti === echain_shared_articles_1.MontageSetOpti.BEFESTIGUNGSSATZ;
    }
    isBefestigungInnen() {
        return this.opti === echain_shared_articles_1.MontageSetOpti.BEFESTIGUNG_INNEN_MIT_C_PROFIL;
    }
    isBefestigungAussen() {
        return this.opti === echain_shared_articles_1.MontageSetOpti.BEFESTIGUNG_AUSSEN_MIT_C_PROFIL;
    }
    calculateAnzahl(fuehrungsrinne, anzahlRinneOhneGleitschiene, anzahlRinneMitGleitschiene, useFestpunktmodul) {
        let count;
        if (fuehrungsrinne.typ === echain_shared_articles_1.FuehrungsrinneTyp.SuperAlu) {
            count = (0, echain_math_1.calcFuehrungsrinneSuperAlu_AnzahlMontageSets_TA1Q)(anzahlRinneOhneGleitschiene, anzahlRinneMitGleitschiene);
        }
        else if (fuehrungsrinne.typ === echain_shared_articles_1.FuehrungsrinneTyp.Stahl) {
            if (fuehrungsrinne.isFuehrungsrinneOhneMontageSet()) {
                count = (0, echain_math_1.calcFuehrungsrinneStahlOhneFPMod_AnzahlMontageSets_TA1Q)(anzahlRinneOhneGleitschiene, anzahlRinneMitGleitschiene);
            }
            else if (useFestpunktmodul) {
                const anzahlFP = (0, echain_math_1.calcFuehrungsrinneStahl_AnzahlFP_TFP1Q)();
                count = (0, echain_math_1.calcFuehrungsrinneStahl_AnzahlMontageSets_TA1Q)(anzahlRinneOhneGleitschiene, anzahlFP, anzahlRinneMitGleitschiene);
            }
            else {
                count = (0, echain_math_1.calcFuehrungsrinneSuperAlu_AnzahlMontageSets_TA1Q)(anzahlRinneOhneGleitschiene, anzahlRinneMitGleitschiene);
            }
        }
        return count;
    }
}
exports.MontageSet = MontageSet;
//# sourceMappingURL=montage-set.js.map